export const MIN_PRIVACY_NOTICE = 0;
export const LATEST_PRIVACY_NOTICE = 1;
export const UNREDACT_TICKETS_TERMS_VERSION = 1;
